import React, {Component} from 'react';
import * as THREE from 'three';

const initialState = {
    faces: [],
    faceVertexUvs: [],
    vertices: []
};

export default class PlanetTerrain extends Component {

    state = initialState;

    componentDidMount() {
        const {center, point, region, altitude} = this.props;
        this.setGeometry(center, point, region, altitude);
    }

    componentWillReceiveProps({center, point, region, altitude}) {
        if (point !== this.props.point || region !== this.props.region) {
            this.setGeometry(center, point, region, altitude);
        } else if (altitude !== this.props.altitude) {
            const geometry = new THREE.Geometry(), {vertices, faces} = this.state;
            geometry.vertices = this.setGeometryVertices(vertices, altitude, region.length);
            geometry.faces = faces;
            this.setGeometryProps(geometry);
        }
    }

    shouldComponentUpdate(props, {vertices}) {
        return vertices !== this.state.vertices;
    }

    setGeometry = (center, point, region, altitude) => {
        const vertices = region.map(vertice => new THREE.Vector3(...vertice)),
            geometry = new THREE.Geometry(),
            getNextIndex = v => v === vertices.length - 1
                ? 0
                : v + 1;
        geometry.vertices = this.setGeometryVertices([
            ...vertices,
            new THREE.Vector3(...point),
            center
        ], altitude, region.length);
        // Compute Faces
        geometry.faces = vertices.reduce((faces, vertice, v) => faces.concat([
            new THREE.Face3(vertices.length, v, getNextIndex(v)),
            new THREE.Face3(vertices.length + 1, getNextIndex(v), v)
        ]), []);
        this.setGeometryProps(geometry);
    }

    setGeometryProps = (geometry) => {
        geometry.computeFaceNormals();
        this.setState(
            {faces: geometry.faces, faceVertexUvs: geometry.faceVertexUvs, vertices: geometry.vertices}
        );
        geometry.dispose();
    }

    setGeometryVertices = (vertices, altitude, length) => {
        const distance = Math.max(altitude, 0);
        return vertices.map((vertice, v) => vertice.setLength(
            v <= length
                ? distance
                : 0
        ));
    }

    render() {
        const {biomeId} = this.props, {vertices, faces, faceVertexUvs} = this.state;
        return <mesh>
            <geometry vertices={vertices} faces={faces} faceVertexUvs={faceVertexUvs}/>
            <materialResource resourceId={biomeId}/>
        </mesh>;
    }
}


// WEBPACK FOOTER //
// ./src/apps/scene-planet/scene/planet/terrain.js